/**
 * Help / Support panel open & close — open_help / close_help.
 *
 * Mounted from Available247 (the top-bar "Help" button). Drives the same
 * `setIsSupportDrawerOpen` the button toggles. Collapses the copilot
 * panel while the drawer is open. The per-option actions (call / email /
 * chat / feature request / raise ticket / schedule) live in
 * SupportOptions (useCopilotHelpOptionsActions), which mounts with the
 * drawer.
 */

import { useCopilotAction } from "./actionRegistry";

const OPEN_DESCRIPTOR = Object.freeze({
  name: "open_help",
  description: "Implemented by noki-fe (Available247.setIsSupportDrawerOpen(true)).",
  classification: "READ",
  parameters: [],
});

const CLOSE_DESCRIPTOR = Object.freeze({
  name: "close_help",
  description: "Implemented by noki-fe (Available247.setIsSupportDrawerOpen(false)).",
  classification: "READ",
  parameters: [],
});

export function useCopilotHelpActions({ isOpen, onOpen, onClose }) {
  useCopilotAction(OPEN_DESCRIPTOR, async () => {
    if (typeof onOpen !== "function") {
      throw new Error("host_exception: help open not wired.");
    }
    if (!isOpen) onOpen();
    return {
      opened: true,
      next_step:
        "The Help panel is open. The user can say: call support, email support, open chat, feature request, raise a ticket, or schedule a meeting.",
    };
  });

  useCopilotAction(CLOSE_DESCRIPTOR, async () => {
    if (typeof onClose !== "function") {
      throw new Error("host_exception: help close not wired.");
    }
    if (isOpen) onClose();
    return { closed: true };
  });
}
